var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseModal',{attrs:{"title":_vm.modalTitle,"value":_vm.open,"headerClass":"py-3"},on:{"close":_vm.close}},[[_c('AddEditCategoryForm',{on:{"onSuccess":_vm.close}})]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }